module.exports = "\n.ctab-content {\n    padding-top: 5px;\n    min-height: 725px;\n    padding-bottom: 10px;\n}"